import BookOpen from 'plaid-threads/Icons/BookOpen';
import Link from 'plaid-threads/Icons/Link';
import Video from 'plaid-threads/Icons/Video';

import styles from './ChatSources.module.scss';
import { Source } from './types';

// This is a ChatSources component that takes in a list of sources and renders them as a list of links
interface Props {
  sources: Array<Source>;
}
const ChatSources = ({ sources }: Props) => {
  return (
    <div className={styles.chatSources}>
      <div className={styles.sourcesTitle}>REFERENCES</div>
      <ul className={styles.sourcesList}>
        {sources.map((source: { url: string; title: string }, index) => {
          let sourceUrl = <Link className={styles.smallishIcon} />;
          if (source.url.includes('youtube.com')) {
            sourceUrl = <Video className={styles.smallishIcon} />;
          } else if (source.url.includes('.pdf')) {
            sourceUrl = <BookOpen className={styles.smallishIcon} />;
          }
          return (
            <li className={styles.sourcesListItem} key={index}>
              <a
                className={styles.sourcesListItemAnchor}
                href={source.url}
                target='_blank'
                rel='noopener noreferrer'
              >
                <span className={styles.sourcesListText}>{source.title}</span>
              </a>
              {sourceUrl}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

ChatSources.displayName = 'ChatSources';
export default ChatSources;
